var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "settings",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "art"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_105",
    "data-name": "Ellipse 105",
    cx: 2.469,
    cy: 2.469,
    r: 2.469,
    transform: "translate(13.531 13.531)",
    fill: "none",
    stroke: "#3c4347",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10646",
    "data-name": "Path 10646",
    d: "M14.9,8.1l-.545,1.919a6.176,6.176,0,0,0-1.413.583l-1.745-.97-1.56,1.56.97,1.745a6.176,6.176,0,0,0-.583,1.413L8.1,14.9V17.1l1.919.545a6.176,6.176,0,0,0,.583,1.413l-.97,1.745,1.56,1.56,1.745-.97a6.176,6.176,0,0,0,1.413.583L14.9,23.9H17.1l.545-1.919a6.176,6.176,0,0,0,1.413-.583l1.745.97,1.56-1.56-.97-1.745a6.176,6.176,0,0,0,.583-1.413L23.9,17.1V14.9l-1.919-.545a6.176,6.176,0,0,0-.583-1.413l.97-1.745-1.56-1.56-1.745.97a6.176,6.176,0,0,0-1.413-.583L17.1,8.1Z",
    fill: "none",
    stroke: "#3c4347",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "square"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1807",
    "data-name": "Rectangle 1807",
    width: 32,
    height: 32,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.863e60cfef0f0bff2fcb090f3923be1a.svg";
export { ForwardRef as ReactComponent };